import axios from "axios";
export const baseAPI = 'api/';
export default axios.create({
    baseURL: baseAPI,
    headers: {
        "Content-Type": "application/json",
    }
});